"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ImportService", {
    enumerable: true,
    get: function() {
        return ImportService;
    }
});
const _common = require("@nestjs/common");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _nocodbsdk = require("nocodb-sdk");
const _objecthash = /*#__PURE__*/ _interop_require_default(require("object-hash"));
const _papaparse = /*#__PURE__*/ _interop_require_default(require("papaparse"));
const _cli = require("src/cli");
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _helpers = require("../../helpers");
const _linkHelpers = require("~/helpers/linkHelpers");
const _modelUtils = require("~/utils/modelUtils");
const _rowColorViewHelpers = require("~/helpers/rowColorViewHelpers");
const _helpers1 = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _models = require("~/models");
const _bulkdataaliasservice = require("~/services/bulk-data-alias.service");
const _calendarsservice = require("~/services/calendars.service");
const _columnsservice = require("~/services/columns.service");
const _filtersservice = require("~/services/filters.service");
const _formcolumnsservice = require("~/services/form-columns.service");
const _formsservice = require("~/services/forms.service");
const _galleriesservice = require("~/services/galleries.service");
const _gridcolumnsservice = require("~/services/grid-columns.service");
const _gridsservice = require("~/services/grids.service");
const _hooksservice = require("~/services/hooks.service");
const _kanbansservice = require("~/services/kanbans.service");
const _sortsservice = require("~/services/sorts.service");
const _tablesservice = require("~/services/tables.service");
const _viewcolumnsservice = require("~/services/view-columns.service");
const _viewsservice = require("~/services/views.service");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ImportService = class ImportService {
    async importUsers(context, _payload) {
        _catchError.NcError.get(context).notImplemented('Import users not implemented');
    }
    async importScripts(_context, _param) {
    // Not Implemented
    }
    async importDashboards(_context, _param) {
        return _param.idMap;
    //  create dashboards
    }
    async importWorkflows(_context, _param) {
        return _param.idMap;
    //  create workflows
    }
    async importPermissions(_context, _param) {
    //  create permissions
    }
    async importModels(context, param) {
        var _param_targetContext;
        const targetContext = (_param_targetContext = param.targetContext) != null ? _param_targetContext : context;
        const hrTime = (0, _helpers.initTime)();
        const ncMeta = _Noco.default.ncMeta;
        // structured id to db id
        const idMap = new Map();
        const externalIdMap = new Map();
        const getIdOrExternalId = (k)=>{
            return idMap.get(k) || externalIdMap.get(k);
        };
        const base = await _models.Base.get(context, param.baseId);
        if (!base) return _catchError.NcError.baseNotFound(param.baseId);
        const source = await _models.Source.get(context, param.sourceId);
        if (!source) return _catchError.NcError.sourceNotFound(param.sourceId);
        const sqlUi = _nocodbsdk.SqlUiFactory.create(await source.getConnectionConfig());
        const tableReferences = new Map();
        const linkMap = new Map();
        param.data = await (0, _modelUtils.validateImportSchema)(context, Array.isArray(param.data) ? param.data : param.data.models);
        // allow existing model to be linked
        if (param.existingModel) param.externalModels = [
            param.existingModel,
            ...param.externalModels
        ];
        // allow existing models to be linked
        if (param.externalModels) {
            for (const model of param.externalModels){
                if (model.base_id !== param.baseId) continue;
                externalIdMap.set(`${model.base_id}::${model.source_id}::${model.id}`, model.id);
                await model.getColumns(context);
                await model.getViews(context);
                const primaryKey = model.primaryKey;
                if (primaryKey) {
                    idMap.set(`${model.base_id}::${model.source_id}::${model.id}::${primaryKey.id}`, primaryKey.id);
                }
                for (const col of model.columns){
                    externalIdMap.set(`${model.base_id}::${model.source_id}::${model.id}::${col.id}`, col.id);
                }
                for (const view of model.views){
                    externalIdMap.set(`${model.base_id}::${model.source_id}::${model.id}::${view.id}`, view.id);
                }
                const hooks = await _models.Hook.list(context, {
                    fk_model_id: model.id
                });
                for (const hook of hooks){
                    externalIdMap.set(`${model.base_id}::${model.source_id}::${model.id}::${hook.id}`, hook.id);
                }
            }
        }
        (0, _helpers.elapsedTime)(hrTime, 'generate id map for external models', 'importModels');
        // create tables with static columns
        for (const data of param.data){
            const modelData = data.model;
            const isSystemTimestamp = (col)=>col.system && [
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime
                ].includes(col.uidt);
            // we exclude all virtual column except system CreatedTime and LastModifiedTime
            // we also include cols marked as pk even if considered virtual
            const eitherSystemTimestampOrNotVirtual = (col)=>isSystemTimestamp(col) || !(0, _nocodbsdk.isVirtualCol)(col) || col.pk;
            const reducedColumnSet = modelData.columns.filter((a)=>eitherSystemTimestampOrNotVirtual(a) && a.uidt !== _nocodbsdk.UITypes.ForeignKey && !(0, _nocodbsdk.isAIPromptCol)(a) && (param.importColumnIds ? param.importColumnIds.includes((0, _exportImportHelpers.getEntityIdentifier)(a.id)) : true));
            // create table with static columns
            const table = param.existingModel || await this.tablesService.tableCreate(targetContext, {
                baseId: targetContext.base_id,
                sourceId: targetContext.base_id !== context.base_id ? undefined : source.id,
                user: param.user,
                table: (0, _exportImportHelpers.withoutId)(_extends({}, modelData, {
                    columns: reducedColumnSet.map((a)=>(0, _exportImportHelpers.withoutId)(a))
                })),
                req: param.req,
                isDuplicateOperation: param.isDuplicateOperation
            });
            idMap.set(modelData.id, table.id);
            if (param.existingModel) {
                // if we have existingModel param, it means duplicate column
                if (reducedColumnSet.length) {
                    for (const col of reducedColumnSet){
                        var _col_dt;
                        col.dt = (_col_dt = col.dt) != null ? _col_dt : sqlUi.getDataTypeForUiType(col).dt;
                        const freshModelData = await this.columnsService.columnAdd(context, {
                            tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                            column: (0, _exportImportHelpers.withoutId)(_extends({}, col)),
                            req: param.req,
                            user: param.user,
                            columnWebhookManager: param.columnWebhookManager
                        });
                        for (const nColumn of freshModelData.columns){
                            if (nColumn.title === col.title) {
                                idMap.set(col.id, nColumn.id);
                                break;
                            }
                        }
                    }
                }
            } else {
                // map column id's with new created column id's
                for (const col of table.columns){
                    var _col_dt1;
                    col.dt = (_col_dt1 = col.dt) != null ? _col_dt1 : sqlUi.getDataTypeForUiType(col).dt;
                    const colRef = modelData.columns.find((a)=>a.column_name && (0, _helpers1.sanitizeColumnName)(a.column_name, source.type) === col.column_name);
                    // if column is not found, it means not present in the import data and should be skipped
                    if (colRef) {
                        idMap.set(colRef.id, col.id);
                    }
                    // setval for auto increment column in pg
                    if (source.type === 'pg') {
                        if (modelData.pgSerialLastVal) {
                            if (col.ai) {
                                const baseModel = await _models.Model.getBaseModelSQL(targetContext, {
                                    id: table.id,
                                    viewId: null,
                                    dbDriver: await _NcConnectionMgrv2.default.get(source)
                                });
                                const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
                                await sqlClient.raw(`SELECT setval(pg_get_serial_sequence('??', ?), ?);`, [
                                    baseModel.getTnPath(table.table_name),
                                    col.column_name,
                                    modelData.pgSerialLastVal
                                ]);
                            }
                        }
                    }
                }
            }
            tableReferences.set(modelData.id, table);
        }
        // create hooks
        for (const data of param.data){
            if (param.existingModel) break;
            if (!(data == null ? void 0 : data.hooks)) break;
            const modelData = data.model;
            const hookData = data.hooks;
            const table = tableReferences.get(modelData.id);
            for (const hook of hookData){
                const { filters } = hook, rest = _object_without_properties_loose(hook, [
                    "filters"
                ]);
                const hookData = (0, _exportImportHelpers.withoutId)(_extends({}, rest));
                const hk = await this.hooksService.hookCreate(targetContext, {
                    tableId: table.id,
                    hook: _extends({}, hookData),
                    req: param.req
                }, {
                    isTableDuplicate: true
                });
                if (!hk) continue;
                idMap.set(hook.id, hk.id);
            }
        }
        // create comments
        for (const data of param.data){
            if (param.existingModel) break;
            if (!(data == null ? void 0 : data.comments)) break;
            const modelData = data.model;
            const commentsData = data.comments;
            const table = tableReferences.get(modelData.id);
            for (const commentD of commentsData){
                const comment = await _models.Comment.insert(targetContext, (0, _exportImportHelpers.withoutId)(_extends({}, commentD, {
                    fk_model_id: table.id,
                    parent_comment_id: idMap.get(commentD.parent_comment_id)
                })));
                idMap.set(commentD.id, comment.id);
            }
        }
        (0, _helpers.elapsedTime)(hrTime, 'create tables with static columns', 'importModels');
        const referencedColumnSet = [];
        const ltarFilterCreateCbks = [];
        // create LTAR columns
        for (const data of param.data){
            const modelData = data.model;
            const table = tableReferences.get(modelData.id);
            const linkedColumnSet = modelData.columns.filter((a)=>(0, _nocodbsdk.isLinksOrLTAR)(a) && !new _models.LinkToAnotherRecordColumn(a.colOptions).isCrossBaseLink() && !a.system && (param.importColumnIds ? param.importColumnIds.includes((0, _exportImportHelpers.getEntityIdentifier)(a.id)) : true));
            for (const col of linkedColumnSet){
                var _col_dt2;
                col.dt = (_col_dt2 = col.dt) != null ? _col_dt2 : sqlUi.getDataTypeForUiType(col).dt;
                if (col.colOptions) {
                    var _col_meta, _colOptions_filter_children, _colOptions_filter;
                    if ((0, _nocodbsdk.isLinksOrLTAR)(col) && (new _models.LinkToAnotherRecordColumn(col.colOptions).isCrossBaseLink() || (col == null ? void 0 : (_col_meta = col.meta) == null ? void 0 : _col_meta.custom))) {
                        continue;
                    }
                    const colOptions = col.colOptions;
                    if (idMap.has(colOptions.fk_related_model_id)) {
                        var _col_meta1;
                        if (colOptions.type === _nocodbsdk.RelationTypes.MANY_TO_MANY || (0, _nocodbsdk.isLinkV2)(col)) {
                            if (!linkMap.has(colOptions.fk_mm_model_id)) {
                                // delete col.column_name as it is not required and will cause ajv error (null for LTAR)
                                delete col.column_name;
                                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                                    tableId: table.id,
                                    column: (0, _exportImportHelpers.withoutId)(_extends({}, col, {
                                        parentId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_child_column_id)),
                                        childId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)),
                                        type: colOptions.type,
                                        virtual: colOptions.virtual,
                                        ur: colOptions.ur,
                                        dr: colOptions.dr,
                                        childViewId: colOptions.fk_target_view_id && getIdOrExternalId(colOptions.fk_target_view_id)
                                    })),
                                    req: param.req,
                                    user: param.user,
                                    columnWebhookManager: param.columnWebhookManager
                                });
                                for (const nColumn of freshModelData.columns){
                                    if (nColumn.title === col.title) {
                                        idMap.set(col.id, nColumn.id);
                                        linkMap.set(colOptions.fk_mm_model_id, nColumn.colOptions.fk_mm_model_id);
                                        break;
                                    }
                                }
                                const childModel = (0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id) === modelData.id ? freshModelData : await _models.Model.get(context, getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)));
                                if ((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id) !== modelData.id) await childModel.getColumns(context);
                                const childColumn = param.data.find((a)=>a.model.id === (0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)).model.columns.find((a)=>{
                                    var _a_colOptions;
                                    return ((_a_colOptions = a.colOptions) == null ? void 0 : _a_colOptions.fk_mm_model_id) === colOptions.fk_mm_model_id && a.id !== col.id;
                                });
                                for (const nColumn of childModel.columns){
                                    var _nColumn_colOptions;
                                    if ((nColumn == null ? void 0 : (_nColumn_colOptions = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions.fk_mm_model_id) === linkMap.get(colOptions.fk_mm_model_id) && nColumn.id !== getIdOrExternalId(col.id)) {
                                        idMap.set(childColumn.id, nColumn.id);
                                        if (nColumn.title !== childColumn.title) {
                                            const titleExists = childModel.columns.find((a)=>a.title === childColumn.title);
                                            if (titleExists) {
                                                childColumn.title = (0, _exportImportHelpers.generateUniqueName)(`${childColumn.title} copy`, childModel.columns.map((a)=>a.title));
                                            }
                                            await this.columnsService.columnUpdate(context, {
                                                columnId: nColumn.id,
                                                column: _extends({}, nColumn, {
                                                    column_name: childColumn.title,
                                                    title: childColumn.title
                                                }),
                                                user: param.user,
                                                req: param.req,
                                                columnWebhookManager: param.columnWebhookManager
                                            });
                                        }
                                        break;
                                    }
                                }
                            }
                        } else if (colOptions.type === _nocodbsdk.RelationTypes.HAS_MANY || colOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && !((_col_meta1 = col.meta) == null ? void 0 : _col_meta1.bt)) {
                            // delete col.column_name as it is not required and will cause ajv error (null for LTAR)
                            delete col.column_name;
                            const freshModelData = await this.columnsService.columnAdd(targetContext, {
                                tableId: table.id,
                                column: (0, _exportImportHelpers.withoutId)(_extends({}, col, {
                                    parentId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)),
                                    childId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_child_column_id)),
                                    type: colOptions.type,
                                    virtual: colOptions.virtual,
                                    ur: colOptions.ur,
                                    dr: colOptions.dr,
                                    childViewId: colOptions.fk_target_view_id && getIdOrExternalId(colOptions.fk_target_view_id)
                                })),
                                req: param.req,
                                user: param.user,
                                columnWebhookManager: param.columnWebhookManager
                            });
                            for (const nColumn of freshModelData.columns){
                                if (nColumn.title === col.title) {
                                    idMap.set(col.id, nColumn.id);
                                    idMap.set(colOptions.fk_parent_column_id, nColumn.colOptions.fk_parent_column_id);
                                    idMap.set(colOptions.fk_child_column_id, nColumn.colOptions.fk_child_column_id);
                                    break;
                                }
                            }
                            const childModel = colOptions.fk_related_model_id === modelData.id ? freshModelData : await _models.Model.get(context, getIdOrExternalId(colOptions.fk_related_model_id));
                            if (colOptions.fk_related_model_id !== modelData.id) await childModel.getColumns(context);
                            const childColumn = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id).model.columns.find((a)=>{
                                var _a_colOptions, _a_colOptions1;
                                return ((_a_colOptions = a.colOptions) == null ? void 0 : _a_colOptions.fk_parent_column_id) === colOptions.fk_parent_column_id && ((_a_colOptions1 = a.colOptions) == null ? void 0 : _a_colOptions1.fk_child_column_id) === colOptions.fk_child_column_id && a.id !== col.id;
                            });
                            for (const nColumn of childModel.columns){
                                var _nColumn_colOptions1, _nColumn_colOptions2;
                                if (nColumn.id !== getIdOrExternalId(col.id) && ((_nColumn_colOptions1 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions1.fk_parent_column_id) === getIdOrExternalId(colOptions.fk_parent_column_id) && ((_nColumn_colOptions2 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions2.fk_child_column_id) === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                    idMap.set(childColumn.id, nColumn.id);
                                    // Rename child column (link column)
                                    if (nColumn.title !== childColumn.title) {
                                        const titleExists = childModel.columns.find((a)=>a.title === childColumn.title);
                                        if (titleExists) {
                                            childColumn.title = (0, _exportImportHelpers.generateUniqueName)(`${childColumn.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                        }
                                        await this.columnsService.columnUpdate(targetContext, {
                                            columnId: nColumn.id,
                                            column: _extends({}, nColumn, {
                                                column_name: childColumn.title,
                                                title: childColumn.title
                                            }),
                                            user: param.user,
                                            req: param.req,
                                            columnWebhookManager: param.columnWebhookManager
                                        });
                                    }
                                }
                                // Rename fk child column
                                if (nColumn.id === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                    var _param_data_find;
                                    const relatedCol = (_param_data_find = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id)) == null ? void 0 : _param_data_find.model.columns.find((a)=>a.id === colOptions.fk_child_column_id);
                                    if (relatedCol) {
                                        if (nColumn.title !== (relatedCol == null ? void 0 : relatedCol.title)) {
                                            const titleExists = childModel.columns.find((a)=>a.title === relatedCol.title);
                                            if (titleExists) {
                                                relatedCol.title = (0, _exportImportHelpers.generateUniqueName)(`${relatedCol.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                            }
                                            await this.columnsService.columnUpdate(targetContext, {
                                                columnId: nColumn.id,
                                                column: _extends({}, nColumn, {
                                                    column_name: relatedCol.column_name,
                                                    title: relatedCol.title
                                                }),
                                                user: param.user,
                                                req: param.req,
                                                columnWebhookManager: param.columnWebhookManager
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    } else if (externalIdMap.has(colOptions.fk_related_model_id)) {
                        var _col_meta2, _col_meta3;
                        if (colOptions.type === _nocodbsdk.RelationTypes.MANY_TO_MANY || (0, _nocodbsdk.isLinkV2)(col)) {
                            if (!linkMap.has(colOptions.fk_mm_model_id)) {
                                var _param_data_find1;
                                // delete col.column_name as it is not required and will cause ajv error (null for LTAR)
                                delete col.column_name;
                                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                                    tableId: table.id,
                                    column: (0, _exportImportHelpers.withoutId)(_extends({}, col, {
                                        parentId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_child_column_id)),
                                        childId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)),
                                        type: colOptions.type,
                                        virtual: colOptions.virtual,
                                        ur: colOptions.ur,
                                        dr: colOptions.dr,
                                        childViewId: colOptions.fk_target_view_id && getIdOrExternalId(colOptions.fk_target_view_id)
                                    }, (0, _nocodbsdk.parseProp)(col.meta).custom ? {
                                        custom: await (0, _linkHelpers.getCustomLinkParam)(targetContext, {
                                            col: (0, _exportImportHelpers.withoutId)(col),
                                            colOptions,
                                            mapId: getIdOrExternalId
                                        }, ncMeta),
                                        is_custom_link: true
                                    } : {})),
                                    req: param.req,
                                    user: param.user,
                                    columnWebhookManager: param.columnWebhookManager
                                });
                                for (const nColumn of freshModelData.columns){
                                    if (nColumn.title === col.title) {
                                        idMap.set(col.id, nColumn.id);
                                        linkMap.set(colOptions.fk_mm_model_id, nColumn.colOptions.fk_mm_model_id);
                                        break;
                                    }
                                }
                                const childModel = (0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id) === modelData.id ? freshModelData : await _models.Model.get(context, getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)));
                                if ((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id) !== modelData.id) await childModel.getColumns(context);
                                const childColumn = (((_param_data_find1 = param.data.find((a)=>a.model.id === (0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id))) == null ? void 0 : _param_data_find1.model) || param.externalModels.find((a)=>a.id === (0, _exportImportHelpers.getEntityIdentifier)((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)))).columns.find((a)=>{
                                    var _a_colOptions, _a_colOptions1;
                                    return ((_a_colOptions = a.colOptions) == null ? void 0 : _a_colOptions.fk_mm_model_id) === colOptions.fk_mm_model_id && a.id !== col.id || ((_a_colOptions1 = a.colOptions) == null ? void 0 : _a_colOptions1.fk_mm_model_id) === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_mm_model_id) && a.id !== (0, _exportImportHelpers.getEntityIdentifier)(col.id);
                                });
                                for (const nColumn of childModel.columns){
                                    var _nColumn_colOptions3;
                                    if ((nColumn == null ? void 0 : (_nColumn_colOptions3 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions3.fk_mm_model_id) === linkMap.get(colOptions.fk_mm_model_id) && nColumn.id !== getIdOrExternalId(col.id)) {
                                        if (childColumn.id.includes('::')) {
                                            idMap.set(childColumn.id, nColumn.id);
                                        } else {
                                            idMap.set(`${childColumn.base_id}::${childColumn.source_id}::${childColumn.fk_model_id}::${childColumn.id}`, nColumn.id);
                                        }
                                        if (nColumn.title !== childColumn.title) {
                                            const titleExists = childModel.columns.find((a)=>a.title === childColumn.title);
                                            if (titleExists) {
                                                childColumn.title = (0, _exportImportHelpers.generateUniqueName)(`${childColumn.title} copy`, childModel.columns.map((a)=>a.title));
                                            }
                                            await this.columnsService.columnUpdate(targetContext, {
                                                columnId: nColumn.id,
                                                column: _extends({}, nColumn, {
                                                    column_name: childColumn.title,
                                                    title: childColumn.title
                                                }),
                                                user: param.user,
                                                req: param.req,
                                                columnWebhookManager: param.columnWebhookManager
                                            });
                                        }
                                        break;
                                    }
                                }
                            }
                        } else if (colOptions.type === _nocodbsdk.RelationTypes.HAS_MANY || colOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && !((_col_meta2 = col.meta) == null ? void 0 : _col_meta2.bt)) {
                            if (!linkMap.has(`${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`)) {
                                var _param_data_find2;
                                // delete col.column_name as it is not required and will cause ajv error (null for LTAR)
                                delete col.column_name;
                                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                                    tableId: table.id,
                                    column: (0, _exportImportHelpers.withoutId)(_extends({}, col, {
                                        parentId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)),
                                        childId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_child_column_id)),
                                        type: colOptions.type,
                                        virtual: colOptions.virtual,
                                        ur: colOptions.ur,
                                        dr: colOptions.dr,
                                        childViewId: colOptions.fk_target_view_id && getIdOrExternalId(colOptions.fk_target_view_id)
                                    }, (0, _nocodbsdk.parseProp)(col.meta).custom ? {
                                        custom: await (0, _linkHelpers.getCustomLinkParam)(targetContext, {
                                            col: (0, _exportImportHelpers.withoutId)(col),
                                            colOptions,
                                            mapId: getIdOrExternalId
                                        }, ncMeta),
                                        is_custom_link: true
                                    } : {})),
                                    req: param.req,
                                    user: param.user,
                                    apiVersion: _nocodbsdk.NcApiVersion.V2,
                                    columnWebhookManager: param.columnWebhookManager
                                });
                                linkMap.set(`${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`, `${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`);
                                for (const nColumn of freshModelData.columns){
                                    if (nColumn.title === col.title) {
                                        idMap.set(col.id, nColumn.id);
                                        idMap.set(colOptions.fk_parent_column_id, nColumn.colOptions.fk_parent_column_id);
                                        idMap.set(colOptions.fk_child_column_id, nColumn.colOptions.fk_child_column_id);
                                        break;
                                    }
                                }
                                const childModel = colOptions.fk_related_model_id === modelData.id ? freshModelData : await _models.Model.get(context, getIdOrExternalId(colOptions.fk_related_model_id));
                                if (colOptions.fk_related_model_id !== modelData.id) await childModel.getColumns(context);
                                const childColumn = (((_param_data_find2 = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id)) == null ? void 0 : _param_data_find2.model) || param.externalModels.find((a)=>a.id === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_related_model_id))).columns.find((a)=>{
                                    var _a_colOptions, _a_colOptions1, _a_colOptions2, _a_colOptions3;
                                    return ((_a_colOptions = a.colOptions) == null ? void 0 : _a_colOptions.fk_parent_column_id) === colOptions.fk_parent_column_id && ((_a_colOptions1 = a.colOptions) == null ? void 0 : _a_colOptions1.fk_child_column_id) === colOptions.fk_child_column_id && a.id !== col.id || ((_a_colOptions2 = a.colOptions) == null ? void 0 : _a_colOptions2.fk_parent_column_id) === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_parent_column_id) && ((_a_colOptions3 = a.colOptions) == null ? void 0 : _a_colOptions3.fk_child_column_id) === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_child_column_id) && a.id !== (0, _exportImportHelpers.getEntityIdentifier)(col.id);
                                });
                                for (const nColumn of childModel.columns){
                                    var _nColumn_colOptions4, _nColumn_colOptions5;
                                    if (nColumn.id !== getIdOrExternalId(col.id) && ((_nColumn_colOptions4 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions4.fk_parent_column_id) === getIdOrExternalId(colOptions.fk_parent_column_id) && ((_nColumn_colOptions5 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions5.fk_child_column_id) === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                        if (childColumn.id.includes('::')) {
                                            idMap.set(childColumn.id, nColumn.id);
                                        } else {
                                            idMap.set(`${childColumn.base_id}::${childColumn.source_id}::${childColumn.fk_model_id}::${childColumn.id}`, nColumn.id);
                                        }
                                        // Rename child column (link column)
                                        if (nColumn.title !== childColumn.title) {
                                            const titleExists = childModel.columns.find((a)=>a.title === childColumn.title);
                                            if (titleExists) {
                                                childColumn.title = (0, _exportImportHelpers.generateUniqueName)(`${childColumn.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                            }
                                            await this.columnsService.columnUpdate(targetContext, {
                                                columnId: nColumn.id,
                                                column: _extends({}, nColumn, {
                                                    column_name: childColumn.title,
                                                    title: childColumn.title
                                                }),
                                                user: param.user,
                                                req: param.req,
                                                columnWebhookManager: param.columnWebhookManager
                                            });
                                        }
                                        // Rename fk child column
                                        if (nColumn.id === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                            var _param_data_find3;
                                            const relatedCol = (_param_data_find3 = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id)) == null ? void 0 : _param_data_find3.model.columns.find((a)=>a.id === colOptions.fk_child_column_id);
                                            if (relatedCol) {
                                                if (nColumn.title !== (relatedCol == null ? void 0 : relatedCol.title)) {
                                                    const titleExists = childModel.columns.find((a)=>a.title === relatedCol.title);
                                                    if (titleExists) {
                                                        relatedCol.title = (0, _exportImportHelpers.generateUniqueName)(`${relatedCol.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                                    }
                                                    await this.columnsService.columnUpdate(targetContext, {
                                                        columnId: nColumn.id,
                                                        column: _extends({}, nColumn, {
                                                            column_name: relatedCol.column_name,
                                                            title: relatedCol.title
                                                        }),
                                                        user: param.user,
                                                        req: param.req,
                                                        columnWebhookManager: param.columnWebhookManager
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else if (colOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO || colOptions.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_col_meta3 = col.meta) == null ? void 0 : _col_meta3.bt)) {
                            if (!linkMap.has(`${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`)) {
                                var _param_data_find4;
                                // delete col.column_name as it is not required and will cause ajv error (null for LTAR)
                                delete col.column_name;
                                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                                    tableId: table.id,
                                    column: (0, _exportImportHelpers.withoutId)(_extends({}, col, {
                                        parentId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_parent_column_id)),
                                        childId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(colOptions.fk_child_column_id)),
                                        type: colOptions.type,
                                        virtual: colOptions.virtual,
                                        ur: colOptions.ur,
                                        dr: colOptions.dr,
                                        childViewId: colOptions.fk_target_view_id && getIdOrExternalId(colOptions.fk_target_view_id)
                                    }, (0, _nocodbsdk.parseProp)(col.meta).custom ? {
                                        custom: await (0, _linkHelpers.getCustomLinkParam)(targetContext, {
                                            col: (0, _exportImportHelpers.withoutId)(col),
                                            colOptions,
                                            mapId: getIdOrExternalId
                                        }, ncMeta),
                                        is_custom_link: true
                                    } : {})),
                                    req: param.req,
                                    user: param.user,
                                    columnWebhookManager: param.columnWebhookManager
                                });
                                linkMap.set(`${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`, `${colOptions.fk_parent_column_id}::${colOptions.fk_child_column_id}`);
                                for (const nColumn of freshModelData.columns){
                                    if (nColumn.title === col.title) {
                                        idMap.set(col.id, nColumn.id);
                                        idMap.set(colOptions.fk_parent_column_id, nColumn.colOptions.fk_parent_column_id);
                                        idMap.set(colOptions.fk_child_column_id, nColumn.colOptions.fk_child_column_id);
                                        break;
                                    }
                                }
                                const childModel = colOptions.fk_related_model_id === modelData.id ? freshModelData : await _models.Model.get(context, getIdOrExternalId(colOptions.fk_related_model_id));
                                if (colOptions.fk_related_model_id !== modelData.id) await childModel.getColumns(context);
                                const childColumn = (((_param_data_find4 = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id)) == null ? void 0 : _param_data_find4.model) || param.externalModels.find((a)=>a.id === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_related_model_id))).columns.find((a)=>{
                                    var _a_colOptions, _a_colOptions1, _a_colOptions2, _a_colOptions3;
                                    return ((_a_colOptions = a.colOptions) == null ? void 0 : _a_colOptions.fk_parent_column_id) === colOptions.fk_parent_column_id && ((_a_colOptions1 = a.colOptions) == null ? void 0 : _a_colOptions1.fk_child_column_id) === colOptions.fk_child_column_id && a.id !== col.id || ((_a_colOptions2 = a.colOptions) == null ? void 0 : _a_colOptions2.fk_parent_column_id) === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_parent_column_id) && ((_a_colOptions3 = a.colOptions) == null ? void 0 : _a_colOptions3.fk_child_column_id) === (0, _exportImportHelpers.getEntityIdentifier)(colOptions.fk_child_column_id) && a.id !== (0, _exportImportHelpers.getEntityIdentifier)(col.id);
                                });
                                for (const nColumn of childModel.columns){
                                    var _nColumn_colOptions6, _nColumn_colOptions7;
                                    if (nColumn.id !== getIdOrExternalId(col.id) && ((_nColumn_colOptions6 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions6.fk_parent_column_id) === getIdOrExternalId(colOptions.fk_parent_column_id) && ((_nColumn_colOptions7 = nColumn.colOptions) == null ? void 0 : _nColumn_colOptions7.fk_child_column_id) === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                        if (childColumn.id.includes('::')) {
                                            idMap.set(childColumn.id, nColumn.id);
                                        } else {
                                            idMap.set(`${childColumn.base_id}::${childColumn.source_id}::${childColumn.fk_model_id}::${childColumn.id}`, nColumn.id);
                                        }
                                        // Rename child column (link column)
                                        if (nColumn.title !== childColumn.title) {
                                            const titleExists = childModel.columns.find((a)=>a.title === childColumn.title);
                                            if (titleExists) {
                                                childColumn.title = (0, _exportImportHelpers.generateUniqueName)(`${childColumn.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                            }
                                            await this.columnsService.columnUpdate(targetContext, {
                                                columnId: nColumn.id,
                                                column: _extends({}, nColumn, {
                                                    column_name: childColumn.title,
                                                    title: childColumn.title
                                                }),
                                                user: param.user,
                                                req: param.req,
                                                columnWebhookManager: param.columnWebhookManager
                                            });
                                        }
                                    }
                                    // Rename fk child column
                                    if (nColumn.id === getIdOrExternalId(colOptions.fk_child_column_id)) {
                                        var _param_data_find5;
                                        const relatedCol = (_param_data_find5 = param.data.find((a)=>a.model.id === colOptions.fk_related_model_id)) == null ? void 0 : _param_data_find5.model.columns.find((a)=>a.id === colOptions.fk_child_column_id);
                                        if (relatedCol) {
                                            if (nColumn.title !== (relatedCol == null ? void 0 : relatedCol.title)) {
                                                const titleExists = childModel.columns.find((a)=>a.title === relatedCol.title);
                                                if (titleExists) {
                                                    relatedCol.title = (0, _exportImportHelpers.generateUniqueName)(`${relatedCol.title} copy`, childModel.columns.filter((a)=>a.id !== nColumn.id).map((a)=>a.title));
                                                }
                                                await this.columnsService.columnUpdate(targetContext, {
                                                    columnId: nColumn.id,
                                                    column: _extends({}, nColumn, {
                                                        column_name: relatedCol.column_name,
                                                        title: relatedCol.title
                                                    }),
                                                    user: param.user,
                                                    req: param.req,
                                                    columnWebhookManager: param.columnWebhookManager
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // filter creation for LTAR columns
                    if ((_colOptions_filter = colOptions.filter) == null ? void 0 : (_colOptions_filter_children = _colOptions_filter.children) == null ? void 0 : _colOptions_filter_children.length) {
                        ltarFilterCreateCbks.push(async ()=>{
                            var _colOptions_filter;
                            // create filters
                            const filters = (_colOptions_filter = colOptions.filter) == null ? void 0 : _colOptions_filter.children;
                            for (const fl of filters){
                                const fg = await this.filtersService.linkFilterCreate(targetContext, {
                                    columnId: getIdOrExternalId(col.id),
                                    filter: (0, _exportImportHelpers.withoutId)(_extends({}, fl, {
                                        fk_value_col_id: getIdOrExternalId(fl.fk_value_col_id),
                                        fk_link_col_id: getIdOrExternalId(fl.fk_link_col_id),
                                        fk_column_id: getIdOrExternalId(fl.fk_column_id),
                                        fk_parent_id: getIdOrExternalId(fl.fk_parent_id)
                                    })),
                                    user: param.user,
                                    req: param.req
                                });
                                if (fg) {
                                    idMap.set(fl.id, fg.id);
                                }
                            }
                        });
                    }
                }
            }
            referencedColumnSet.push(...modelData.columns.filter((a)=>(a.uidt === _nocodbsdk.UITypes.Lookup || a.uidt === _nocodbsdk.UITypes.Rollup || a.uidt === _nocodbsdk.UITypes.Formula || a.uidt === _nocodbsdk.UITypes.Button || a.uidt === _nocodbsdk.UITypes.QrCode || a.uidt === _nocodbsdk.UITypes.CreatedTime || a.uidt === _nocodbsdk.UITypes.LastModifiedTime || a.uidt === _nocodbsdk.UITypes.CreatedBy || a.uidt === _nocodbsdk.UITypes.LastModifiedBy || a.uidt === _nocodbsdk.UITypes.Barcode || (0, _nocodbsdk.isAIPromptCol)(a)) && (param.importColumnIds ? param.importColumnIds.includes((0, _exportImportHelpers.getEntityIdentifier)(a.id)) : true)));
        }
        (0, _helpers.elapsedTime)(hrTime, 'create LTAR columns', 'importModels');
        const sortedReferencedColumnSet = [];
        // sort referenced columns to avoid referencing before creation
        for (const col of referencedColumnSet){
            var _col_colOptions, _col_colOptions1, _col_colOptions2, _col_colOptions3, _col_colOptions4;
            const relatedColIds = [];
            if ((_col_colOptions = col.colOptions) == null ? void 0 : _col_colOptions.fk_lookup_column_id) {
                relatedColIds.push(col.colOptions.fk_lookup_column_id);
            }
            if ((_col_colOptions1 = col.colOptions) == null ? void 0 : _col_colOptions1.fk_rollup_column_id) {
                relatedColIds.push(col.colOptions.fk_rollup_column_id);
            }
            if ((_col_colOptions2 = col.colOptions) == null ? void 0 : _col_colOptions2.formula) {
                var _col_colOptions5;
                const colIds = (_col_colOptions5 = col.colOptions) == null ? void 0 : _col_colOptions5.formula.match(RegExp("(?<=\\{\\{).*?(?=\\}\\})", "gm"));
                if (colIds && colIds.length > 0) {
                    relatedColIds.push(...col.colOptions.formula.match(RegExp("(?<=\\{\\{).*?(?=\\}\\})", "gm")));
                }
            }
            if ((_col_colOptions3 = col.colOptions) == null ? void 0 : _col_colOptions3.fk_qr_value_column_id) {
                relatedColIds.push(col.colOptions.fk_qr_value_column_id);
            }
            if ((_col_colOptions4 = col.colOptions) == null ? void 0 : _col_colOptions4.fk_barcode_value_column_id) {
                relatedColIds.push(col.colOptions.fk_barcode_value_column_id);
            }
            // find the last related column in the sorted array
            let fnd = undefined;
            for(let i = sortedReferencedColumnSet.length - 1; i >= 0; i--){
                if (relatedColIds.includes(sortedReferencedColumnSet[i].id)) {
                    fnd = sortedReferencedColumnSet[i];
                    break;
                }
            }
            if (!fnd) {
                sortedReferencedColumnSet.unshift(col);
            } else {
                sortedReferencedColumnSet.splice(sortedReferencedColumnSet.indexOf(fnd) + 1, 0, col);
            }
        }
        // create referenced columns
        // sort the column sets to create the system columns first
        for (const col of sortedReferencedColumnSet){
            var _col_dt3;
            col.dt = (_col_dt3 = col.dt) != null ? _col_dt3 : sqlUi.getDataTypeForUiType(col).dt;
            const { colOptions } = col, flatCol = _object_without_properties_loose(col, [
                "colOptions"
            ]);
            if (col.uidt === _nocodbsdk.UITypes.Lookup) {
                // Skip if relation column or lookup column can't be mapped (e.g., cross-base lookups)
                if (!getIdOrExternalId(colOptions.fk_relation_column_id)) continue;
                if (!getIdOrExternalId(colOptions.fk_lookup_column_id)) continue;
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        fk_lookup_column_id: getIdOrExternalId(colOptions.fk_lookup_column_id),
                        fk_relation_column_id: getIdOrExternalId(colOptions.fk_relation_column_id)
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.Rollup) {
                // Skip if relation column or rollup column can't be mapped (e.g., cross-base rollups)
                if (!getIdOrExternalId(colOptions.fk_relation_column_id)) continue;
                if (!getIdOrExternalId(colOptions.fk_rollup_column_id)) continue;
                const freshModelData = await this.columnsService.columnAdd(context, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        fk_rollup_column_id: getIdOrExternalId(colOptions.fk_rollup_column_id),
                        fk_relation_column_id: getIdOrExternalId(colOptions.fk_relation_column_id),
                        rollup_function: colOptions.rollup_function
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.Formula) {
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        formula: colOptions.formula,
                        parsed_tree: colOptions.parsed_tree,
                        formula_raw: colOptions.formula_raw
                    })),
                    req: param.req,
                    user: param.user,
                    suppressFormulaError: true,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.Button) {
                var _colOptions_output_column_ids;
                if (base.fk_workspace_id !== colOptions.fk_workspace_id) {
                    colOptions.fk_workspace_id = null;
                    colOptions.fk_integration_id = null;
                    colOptions.model = null;
                }
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        formula: colOptions == null ? void 0 : colOptions.formula,
                        parsed_tree: colOptions == null ? void 0 : colOptions.parsed_tree,
                        formula_raw: colOptions == null ? void 0 : colOptions.formula_raw,
                        label: colOptions == null ? void 0 : colOptions.label,
                        color: colOptions == null ? void 0 : colOptions.color,
                        theme: colOptions == null ? void 0 : colOptions.theme,
                        icon: colOptions == null ? void 0 : colOptions.icon,
                        type: colOptions == null ? void 0 : colOptions.type,
                        fk_webhook_id: getIdOrExternalId(colOptions == null ? void 0 : colOptions.fk_webhook_id),
                        output_column_ids: ((colOptions == null ? void 0 : (_colOptions_output_column_ids = colOptions.output_column_ids) == null ? void 0 : _colOptions_output_column_ids.split(',')) || []).map((a)=>getIdOrExternalId(a)).join(','),
                        fk_integration_id: colOptions == null ? void 0 : colOptions.fk_integration_id,
                        model: colOptions == null ? void 0 : colOptions.model
                    })),
                    req: param.req,
                    user: param.user,
                    suppressFormulaError: true,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if ((0, _nocodbsdk.isAIPromptCol)(col)) {
                if (base.fk_workspace_id !== colOptions.fk_workspace_id) {
                    colOptions.fk_workspace_id = null;
                    colOptions.fk_integration_id = null;
                    colOptions.model = null;
                }
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        fk_integration_id: colOptions.fk_integration_id,
                        model: colOptions.model,
                        prompt_raw: colOptions.prompt_raw
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.CreatedTime || col.uidt === _nocodbsdk.UITypes.LastModifiedTime || col.uidt === _nocodbsdk.UITypes.CreatedBy || col.uidt === _nocodbsdk.UITypes.LastModifiedBy) {
                if (col.system) continue;
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        // provide column_name to avoid ajv error
                        // it will be ignored by the service
                        column_name: 'system',
                        system: false
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.QrCode) {
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        fk_qr_value_column_id: getIdOrExternalId(colOptions.fk_qr_value_column_id)
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            } else if (col.uidt === _nocodbsdk.UITypes.Barcode) {
                flatCol.validate = null;
                const freshModelData = await this.columnsService.columnAdd(targetContext, {
                    tableId: getIdOrExternalId((0, _exportImportHelpers.getParentIdentifier)(col.id)),
                    column: (0, _exportImportHelpers.withoutId)(_extends({}, flatCol, {
                        fk_barcode_value_column_id: getIdOrExternalId(colOptions.fk_barcode_value_column_id)
                    })),
                    req: param.req,
                    user: param.user,
                    columnWebhookManager: param.columnWebhookManager
                });
                for (const nColumn of freshModelData.columns){
                    if (nColumn.title === col.title) {
                        idMap.set(col.id, nColumn.id);
                        break;
                    }
                }
            }
        }
        (0, _helpers.elapsedTime)(hrTime, 'create referenced columns', 'importModels');
        // create views
        const vieProcessQueue = new _pqueue.default({
            concurrency: 3
        });
        for (const data of param.data){
            if (param.existingModel) break;
            const modelData = data.model;
            const viewsData = data.views;
            const table = tableReferences.get(modelData.id);
            // get default view
            await table.getViews(context);
            for (const view of viewsData){
                vieProcessQueue.add(async ()=>{
                    const viewData = (0, _exportImportHelpers.withoutId)(_extends({}, view, {
                        meta: _rowColorViewHelpers.RowColorViewHelpers.withContext(targetContext).mapMetaColumn({
                            meta: view.meta,
                            idMap: {
                                get: getIdOrExternalId
                            }
                        })
                    }));
                    const vw = await this.createView(targetContext, idMap, table, viewData, table.views, param.user, param.req);
                    if (!vw) return;
                    idMap.set(view.id, vw.id);
                    // create filters
                    const filters = view.filter.children;
                    for (const fl of filters){
                        const fg = await this.filtersService.filterCreate(targetContext, {
                            viewId: vw.id,
                            filter: (0, _exportImportHelpers.withoutId)(_extends({}, fl, {
                                fk_parent_column_id: getIdOrExternalId(fl.fk_parent_column_id),
                                fk_column_id: getIdOrExternalId(fl.fk_column_id),
                                fk_parent_id: getIdOrExternalId(fl.fk_parent_id)
                            })),
                            user: param.user,
                            req: param.req
                        });
                        idMap.set(fl.id, fg.id);
                    }
                    // create sorts
                    for (const sr of view.sorts){
                        await this.sortsService.sortCreate(targetContext, {
                            viewId: vw.id,
                            sort: (0, _exportImportHelpers.withoutId)(_extends({}, sr, {
                                fk_column_id: getIdOrExternalId(sr.fk_column_id)
                            })),
                            req: param.req
                        });
                    }
                    // update view columns
                    const vwColumns = await this.viewColumnsService.columnList(targetContext, {
                        viewId: vw.id
                    });
                    const vwColumnPayloads = new Map();
                    for (const cl of vwColumns){
                        const fcl = view.columns.find((a)=>a.fk_column_id === (0, _exportImportHelpers.reverseGet)(idMap, cl.fk_column_id));
                        if (!fcl) continue;
                        const calendarColProperties = vw.type === _nocodbsdk.ViewTypes.CALENDAR ? {
                            bold: fcl.bold,
                            italic: fcl.italic,
                            underline: fcl.underline
                        } : {};
                        vwColumnPayloads.set(cl.fk_column_id, _extends({
                            id: cl.fk_column_id,
                            show: fcl.show,
                            order: fcl.order
                        }, calendarColProperties));
                    }
                    switch(vw.type){
                        case _nocodbsdk.ViewTypes.GRID:
                            for (const cl of vwColumns){
                                const fcl = view.columns.find((a)=>a.fk_column_id === (0, _exportImportHelpers.reverseGet)(idMap, cl.fk_column_id));
                                if (!fcl) continue;
                                const { fk_column_id } = fcl, rest = _object_without_properties_loose(fcl, [
                                    "fk_column_id"
                                ]);
                                vwColumnPayloads.set(cl.fk_column_id, _extends({}, vwColumnPayloads.get(cl.fk_column_id), (0, _exportImportHelpers.withoutNull)(rest)));
                            }
                            break;
                        case _nocodbsdk.ViewTypes.FORM:
                            for (const cl of vwColumns){
                                const fcl = view.columns.find((a)=>a.fk_column_id === (0, _exportImportHelpers.reverseGet)(idMap, cl.fk_column_id));
                                if (!fcl) continue;
                                const { fk_column_id } = fcl, rest = _object_without_properties_loose(fcl, [
                                    "fk_column_id"
                                ]);
                                vwColumnPayloads.set(cl.fk_column_id, _extends({}, vwColumnPayloads.get(cl.fk_column_id), (0, _exportImportHelpers.withoutNull)(rest)));
                            }
                            break;
                        case _nocodbsdk.ViewTypes.GALLERY:
                        case _nocodbsdk.ViewTypes.KANBAN:
                        case _nocodbsdk.ViewTypes.CALENDAR:
                            break;
                    }
                    await this.viewColumnsService.columnsUpdate(targetContext, {
                        viewId: vw.id,
                        columns: Array.from(vwColumnPayloads.values()),
                        req: param.req
                    });
                    // fix view order (view insert will always put it at the end)
                    if (view.order !== vw.order) {
                        await this.viewsService.viewUpdate(targetContext, {
                            viewId: vw.id,
                            view: {
                                order: view.order
                            },
                            user: param.user,
                            req: param.req
                        });
                    }
                    (0, _helpers.elapsedTime)(hrTime, 'view created for view: ' + vw.id, 'importModels');
                });
            }
        }
        await vieProcessQueue.onIdle();
        // create row color info
        for (const data of param.data){
            var _data_rowColorConditions_rowColorConditions, _data_rowColorConditions, _data_rowColorConditions_filters, _data_rowColorConditions1;
            if (param.existingModel) break;
            if (((_data_rowColorConditions = data.rowColorConditions) == null ? void 0 : (_data_rowColorConditions_rowColorConditions = _data_rowColorConditions.rowColorConditions) == null ? void 0 : _data_rowColorConditions_rowColorConditions.length) > 0) {
                await ncMeta.bulkMetaInsert(targetContext.workspace_id, targetContext.base_id, _cli.MetaTable.ROW_COLOR_CONDITIONS, data.rowColorConditions.rowColorConditions.map((rc)=>{
                    return _extends({}, rc, {
                        fk_view_id: getIdOrExternalId(rc.fk_view_id)
                    });
                }));
            }
            if (((_data_rowColorConditions1 = data.rowColorConditions) == null ? void 0 : (_data_rowColorConditions_filters = _data_rowColorConditions1.filters) == null ? void 0 : _data_rowColorConditions_filters.length) > 0) {
                await ncMeta.bulkMetaInsert(targetContext.workspace_id, targetContext.base_id, _cli.MetaTable.FILTER_EXP, data.rowColorConditions.filters.map((flt)=>{
                    return _extends({}, flt, {
                        fk_column_id: getIdOrExternalId(flt.fk_column_id)
                    });
                }));
            }
        }
        (0, _helpers.elapsedTime)(hrTime, 'create views', 'importModels');
        // create hook filters for hooks
        for (const data of param.data){
            if (param.existingModel) break;
            if (!(data == null ? void 0 : data.hooks)) break;
            const hookData = data.hooks;
            for (const hook of hookData){
                const { filters } = hook;
                // create filters
                for (const fl of filters){
                    const fg = await this.filtersService.hookFilterCreate(targetContext, {
                        hookId: getIdOrExternalId(hook.id),
                        filter: (0, _exportImportHelpers.withoutId)(_extends({}, fl, {
                            fk_column_id: getIdOrExternalId(fl.fk_column_id),
                            fk_parent_id: getIdOrExternalId(fl.fk_parent_id)
                        })),
                        user: param.user,
                        req: param.req
                    });
                    idMap.set(fl.id, fg.id);
                }
            }
        }
        (0, _helpers.elapsedTime)(hrTime, 'create hooks', 'importModels');
        // create permissions
        for (const data of param.data){
            if (param.existingModel) break;
            if (!(data == null ? void 0 : data.permissions)) break;
            await this.importPermissions(targetContext, {
                permissions: data.permissions,
                getIdOrExternalId,
                req: param.req
            });
        }
        // create link filter, triggers at the end since it requires all columns to be created
        for (const ltarFilterCreateCbk of ltarFilterCreateCbks){
            await ltarFilterCreateCbk();
        }
        (0, _helpers.elapsedTime)(hrTime, 'create link filters', 'importModels');
        return idMap;
    }
    async createView(context, idMap, md, vw, views, user, req) {
        if (vw == null ? void 0 : vw.is_default) {
            const view = views == null ? void 0 : views[0];
            if (view) {
                // update meta and coloring mode to default view
                await _models.View.update(context, view.id, (0, _extractProps.extractProps)(vw, [
                    'title',
                    'show_system_fields',
                    'meta',
                    'expanded_record_mode',
                    'row_coloring_mode',
                    'attachment_mode_column_id'
                ]));
                const gridData = (0, _exportImportHelpers.withoutNull)(vw.view);
                if (gridData) {
                    await this.gridsService.gridViewUpdate(context, {
                        viewId: view.id,
                        grid: gridData,
                        req
                    });
                }
            }
            return view;
        }
        switch(vw.type){
            case _nocodbsdk.ViewTypes.GRID:
                {
                    const gview = await this.gridsService.gridViewCreate(context, {
                        tableId: md.id,
                        grid: vw,
                        ownedBy: vw.owned_by,
                        req
                    });
                    const gridData = (0, _exportImportHelpers.withoutNull)(vw.view);
                    if (gridData) {
                        await this.gridsService.gridViewUpdate(context, {
                            viewId: gview.id,
                            grid: gridData,
                            req
                        });
                    }
                    return gview;
                }
            case _nocodbsdk.ViewTypes.FORM:
                {
                    const fview = await this.formsService.formViewCreate(context, {
                        tableId: md.id,
                        body: vw,
                        user,
                        ownedBy: vw.owned_by,
                        req
                    });
                    const formData = (0, _exportImportHelpers.withoutNull)(vw.view);
                    if (formData) {
                        await this.formsService.formViewUpdate(context, {
                            formViewId: fview.id,
                            form: formData,
                            req
                        });
                    }
                    return fview;
                }
            case _nocodbsdk.ViewTypes.CALENDAR:
                {
                    return await this.calendarsService.calendarViewCreate(context, {
                        tableId: md.id,
                        ownedBy: vw.owned_by,
                        calendar: _extends({}, vw, {
                            calendar_range: vw.view.calendar_range.map((a)=>({
                                    fk_from_column_id: idMap.get(a.fk_from_column_id),
                                    fk_to_column_id: idMap.get(a.fk_to_column_id)
                                }))
                        }),
                        user,
                        req
                    });
                }
            case _nocodbsdk.ViewTypes.GALLERY:
                {
                    const glview = await this.galleriesService.galleryViewCreate(context, {
                        tableId: md.id,
                        ownedBy: vw.owned_by,
                        gallery: vw,
                        user,
                        req
                    });
                    const galleryData = (0, _exportImportHelpers.withoutNull)(vw.view);
                    if (galleryData) {
                        for (const [k, v] of Object.entries(galleryData)){
                            switch(k){
                                case 'fk_cover_image_col_id':
                                    var _idMap_get;
                                    galleryData[k] = (_idMap_get = idMap.get(v)) != null ? _idMap_get : null;
                                    break;
                            }
                        }
                        await this.galleriesService.galleryViewUpdate(context, {
                            galleryViewId: glview.id,
                            gallery: galleryData,
                            req
                        });
                    }
                    return glview;
                }
            case _nocodbsdk.ViewTypes.KANBAN:
                {
                    const kview = await this.kanbansService.kanbanViewCreate(context, {
                        tableId: md.id,
                        ownedBy: vw.owned_by,
                        kanban: vw,
                        user,
                        req
                    });
                    const kanbanData = (0, _exportImportHelpers.withoutNull)(vw.view);
                    if (kanbanData) {
                        const grpCol = await _models.Column.get(context, {
                            source_id: md.source_id,
                            colId: idMap.get(kanbanData['fk_grp_col_id'])
                        });
                        for (const [k, v] of Object.entries(kanbanData)){
                            switch(k){
                                case 'fk_grp_col_id':
                                case 'fk_cover_image_col_id':
                                    var _idMap_get1;
                                    kanbanData[k] = (_idMap_get1 = idMap.get(v)) != null ? _idMap_get1 : null;
                                    break;
                                case 'meta':
                                    {
                                        const meta = {};
                                        for (const [mk, mv] of Object.entries(v)){
                                            // copy non-array meta as it is
                                            if (!Array.isArray(mv)) {
                                                meta[mk] = mv;
                                                continue;
                                            }
                                            const tempVal = [];
                                            for (const vl of mv){
                                                if (vl.fk_column_id) {
                                                    var _grpCol_colOptions_options, _grpCol_colOptions;
                                                    // check if the option is still exists on field option
                                                    // currently any modification on field option
                                                    // is not reflected yet to kanban view
                                                    const metaValueOption = (_grpCol_colOptions = grpCol.colOptions) == null ? void 0 : (_grpCol_colOptions_options = _grpCol_colOptions.options) == null ? void 0 : _grpCol_colOptions_options.find((el)=>el.title === vl.title);
                                                    if (!metaValueOption) {
                                                        continue;
                                                    }
                                                    const id = metaValueOption.id;
                                                    tempVal.push(_extends({}, vl, {
                                                        fk_column_id: idMap.get(vl.fk_column_id),
                                                        id
                                                    }));
                                                } else {
                                                    delete vl.fk_column_id;
                                                    tempVal.push(_extends({}, vl, {
                                                        id: 'uncategorized'
                                                    }));
                                                }
                                            }
                                            // TODO (optional): check grpCol.colOptions.options not exists in tempVal
                                            // and generate that
                                            meta[idMap.get(mk)] = tempVal;
                                        }
                                        kanbanData[k] = meta;
                                        break;
                                    }
                            }
                        }
                        await this.kanbansService.kanbanViewUpdate(context, {
                            kanbanViewId: kview.id,
                            kanban: kanbanData,
                            req
                        });
                    }
                    return kview;
                }
        }
        return null;
    }
    async importBase(context, param) {
        const hrTime = (0, _helpers.initTime)();
        const { user, baseId, sourceId, src, req } = param;
        const destProject = await _models.Base.get(context, baseId);
        const destBase = await _models.Source.get(context, sourceId);
        if (!destProject) return _catchError.NcError.baseNotFound(baseId);
        if (!destBase) return _catchError.NcError.sourceNotFound(sourceId);
        switch(src.type){
            case 'local':
                {
                    const path = src.path.replace(/\/$/, '');
                    const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
                    try {
                        const schema = JSON.parse(await storageAdapter.fileRead(`${path}/schema.json`));
                        (0, _helpers.elapsedTime)(hrTime, 'read schema from file', 'importBase');
                        // store fk_mm_model_id (mm) to link once
                        let handledLinks = [];
                        const idMap = await this.importModels(context, {
                            user,
                            baseId,
                            sourceId,
                            data: schema,
                            req
                        });
                        (0, _helpers.elapsedTime)(hrTime, 'import models schema', 'importBase');
                        if (idMap) {
                            const files = await storageAdapter.getDirectoryList(`${path}/data`);
                            const dataFiles = files.filter((file)=>!file.match(/links\.csv$/));
                            const linkFile = `${path}/data/links.csv`;
                            for (const file of dataFiles){
                                const readStream = await storageAdapter.fileReadByStream(`${path}/data/${file}`, {
                                    encoding: 'utf8'
                                });
                                const modelId = (0, _exportImportHelpers.findWithIdentifier)(idMap, file.replace(/\.csv$/, ''));
                                const model = await _models.Model.get(context, modelId);
                                this.debugLog(`Importing ${model.title}...`);
                                await this.importDataFromCsvStream(context, {
                                    idMap,
                                    dataStream: readStream,
                                    destProject,
                                    destBase,
                                    destModel: model,
                                    req
                                });
                                (0, _helpers.elapsedTime)(hrTime, `import data for ${model.title}`, 'importBase');
                            }
                            // reset timer
                            (0, _helpers.elapsedTime)(hrTime);
                            const linkReadStream = await storageAdapter.fileReadByStream(linkFile, {
                                encoding: 'utf8'
                            });
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            handledLinks = await this.importLinkFromCsvStream(context, {
                                idMap,
                                linkStream: linkReadStream,
                                destProject,
                                destBase,
                                handledLinks
                            });
                            (0, _helpers.elapsedTime)(hrTime, `import links`, 'importBase');
                        }
                    } catch (e) {
                        if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
                        this.logger.error('Error Importing base', e);
                        _catchError.NcError.get(context).internalServerError(e == null ? void 0 : e.message);
                    }
                    break;
                }
            case 'url':
                break;
            case 'file':
                break;
        }
    }
    importDataFromCsvStream(context, param) {
        const { idMap, dataStream, destBase, destProject, destModel, req, skipDuplicates = false } = param;
        const dataHashSet = new Set();
        const headers = [];
        let chunk = [];
        return new Promise((resolve, reject)=>{
            _papaparse.default.parse(dataStream, {
                newline: '\r\n',
                step: async (results, parser)=>{
                    if (!headers.length) {
                        parser.pause();
                        for (const header of results.data){
                            const id = idMap.get(header);
                            if (id) {
                                const col = await _models.Column.get(context, {
                                    source_id: destBase.id,
                                    colId: id
                                });
                                if (col) {
                                    var _col_colOptions, _col_colOptions1, _col_meta;
                                    if (((_col_colOptions = col.colOptions) == null ? void 0 : _col_colOptions.type) === _nocodbsdk.RelationTypes.BELONGS_TO || ((_col_colOptions1 = col.colOptions) == null ? void 0 : _col_colOptions1.type) === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_col_meta = col.meta) == null ? void 0 : _col_meta.bt)) {
                                        const childCol = await _models.Column.get(context, {
                                            source_id: destBase.id,
                                            colId: col.colOptions.fk_child_column_id
                                        });
                                        if (childCol) {
                                            headers.push(childCol.column_name);
                                        } else {
                                            headers.push(null);
                                            this.debugLog(`child column not found (${col.colOptions.fk_child_column_id})`);
                                        }
                                    } else {
                                        headers.push(col.column_name);
                                    }
                                } else {
                                    headers.push(null);
                                    this.debugLog(`column not found (${id})`);
                                }
                            } else {
                                headers.push(null);
                                this.debugLog(`id not found (${header})`);
                            }
                        }
                        parser.resume();
                    } else {
                        if (results.errors.length === 0) {
                            const row = {};
                            for(let i = 0; i < headers.length; i++){
                                if (headers[i]) {
                                    if (results.data[i] !== '') {
                                        if (results.data[i] === '__nc_empty_string__') {
                                            row[headers[i]] = '';
                                        } else {
                                            row[headers[i]] = results.data[i];
                                        }
                                    }
                                }
                            }
                            if (skipDuplicates) {
                                // check if the row already exists
                                const rowHash = (0, _objecthash.default)(row);
                                if (!dataHashSet.has(rowHash)) {
                                    dataHashSet.add(rowHash);
                                    chunk.push(row);
                                }
                            } else {
                                chunk.push(row);
                            }
                            if (chunk.length > 1000) {
                                parser.pause();
                                try {
                                    await this.bulkDataService.bulkDataInsert(context, {
                                        baseName: destProject.id,
                                        tableName: destModel.id,
                                        body: chunk,
                                        cookie: req,
                                        chunkSize: chunk.length + 1,
                                        foreign_key_checks: !!destBase.isMeta(),
                                        raw: true,
                                        // this is to avoid skipping autoincrement column
                                        undo: true
                                    });
                                } catch (e) {
                                    // stop the stream
                                    parser.abort();
                                    reject(e);
                                    return;
                                }
                                chunk = [];
                                parser.resume();
                            }
                        }
                    }
                },
                complete: async ()=>{
                    if (chunk.length > 0) {
                        try {
                            await this.bulkDataService.bulkDataInsert(context, {
                                baseName: destProject.id,
                                tableName: destModel.id,
                                body: chunk,
                                cookie: req,
                                chunkSize: chunk.length + 1,
                                foreign_key_checks: !!destBase.isMeta(),
                                raw: true,
                                // this is to avoid skipping autoincrement column
                                undo: true
                            });
                        } catch (e) {
                            // stop the stream
                            reject(e);
                            return;
                        }
                        chunk = [];
                    }
                    resolve(null);
                }
            });
        });
    }
    // import links and return handled links
    async importLinkFromCsvStream(context, param) {
        const { idMap, linkStream, destBase, destProject, handledLinks } = param;
        const lChunks = {}; // fk_mm_model_id: { rowId, childId }[]
        const insertChunks = async ()=>{
            for (const [k, v] of Object.entries(lChunks)){
                try {
                    if (v.length === 0) continue;
                    await this.bulkDataService.bulkDataInsert(context, {
                        baseName: destProject.id,
                        tableName: k,
                        body: v,
                        cookie: null,
                        chunkSize: 1000,
                        foreign_key_checks: !!destBase.isMeta(),
                        raw: true,
                        // this is to avoid skipping autoincrement column
                        undo: true
                    });
                    lChunks[k] = [];
                } catch (e) {
                    this.logger.error(e);
                    throw e;
                }
            }
        };
        let headersFound = false;
        let childIndex = -1;
        let parentIndex = -1;
        let columnIndex = -1;
        const mmColumns = {};
        const mmParentChild = {};
        return new Promise((resolve, reject)=>{
            _papaparse.default.parse(linkStream, {
                newline: '\r\n',
                step: async (results, parser)=>{
                    if (!headersFound) {
                        for (const [i, header] of Object.entries(results.data)){
                            if (header === 'child') {
                                childIndex = parseInt(i);
                            } else if (header === 'parent') {
                                parentIndex = parseInt(i);
                            } else if (header === 'column') {
                                columnIndex = parseInt(i);
                            }
                        }
                        headersFound = true;
                    } else {
                        if (results.errors.length === 0) {
                            const child = results.data[childIndex];
                            const parent = results.data[parentIndex];
                            const columnId = results.data[columnIndex];
                            if (child && parent && columnId) {
                                if (mmColumns[columnId]) {
                                    // push to chunk
                                    const mmModelId = mmColumns[columnId].colOptions.fk_mm_model_id;
                                    const mm = mmParentChild[mmModelId];
                                    lChunks[mmModelId].push({
                                        [mm.parent]: parent,
                                        [mm.child]: child
                                    });
                                } else {
                                    // get column for the first time
                                    parser.pause();
                                    try {
                                        await insertChunks();
                                    } catch (e) {
                                        parser.abort();
                                        reject(e);
                                        return;
                                    }
                                    const col = await _models.Column.get(context, {
                                        source_id: destBase.id,
                                        colId: (0, _exportImportHelpers.findWithIdentifier)(idMap, columnId)
                                    });
                                    if (col) {
                                        const colOptions = await col.getColOptions(context);
                                        const vChildCol = await colOptions.getMMChildColumn(context);
                                        const vParentCol = await colOptions.getMMParentColumn(context);
                                        mmParentChild[col.colOptions.fk_mm_model_id] = {
                                            parent: vParentCol.column_name,
                                            child: vChildCol.column_name
                                        };
                                        mmColumns[columnId] = col;
                                        handledLinks.push(col.colOptions.fk_mm_model_id);
                                        const mmModelId = col.colOptions.fk_mm_model_id;
                                        // create chunk
                                        lChunks[mmModelId] = [];
                                        // push to chunk
                                        const mm = mmParentChild[mmModelId];
                                        lChunks[mmModelId].push({
                                            [mm.parent]: parent,
                                            [mm.child]: child
                                        });
                                    } else {
                                        this.debugLog(`column not found (${columnId})`);
                                    }
                                    parser.resume();
                                }
                            }
                        }
                    }
                },
                complete: async ()=>{
                    try {
                        await insertChunks();
                    } catch (e) {
                        reject(e);
                        return;
                    }
                    resolve(handledLinks);
                }
            });
        });
    }
    constructor(tablesService, columnsService, filtersService, sortsService, viewColumnsService, gridColumnsService, formColumnsService, gridsService, formsService, galleriesService, calendarsService, kanbansService, bulkDataService, hooksService, viewsService){
        this.tablesService = tablesService;
        this.columnsService = columnsService;
        this.filtersService = filtersService;
        this.sortsService = sortsService;
        this.viewColumnsService = viewColumnsService;
        this.gridColumnsService = gridColumnsService;
        this.formColumnsService = formColumnsService;
        this.gridsService = gridsService;
        this.formsService = formsService;
        this.galleriesService = galleriesService;
        this.calendarsService = calendarsService;
        this.kanbansService = kanbansService;
        this.bulkDataService = bulkDataService;
        this.hooksService = hooksService;
        this.viewsService = viewsService;
        this.debugLog = (0, _debug.default)('nc:jobs:import');
        this.logger = new _common.Logger(ImportService.name);
    }
};
ImportService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService,
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService,
        typeof _sortsservice.SortsService === "undefined" ? Object : _sortsservice.SortsService,
        typeof _viewcolumnsservice.ViewColumnsService === "undefined" ? Object : _viewcolumnsservice.ViewColumnsService,
        typeof _gridcolumnsservice.GridColumnsService === "undefined" ? Object : _gridcolumnsservice.GridColumnsService,
        typeof _formcolumnsservice.FormColumnsService === "undefined" ? Object : _formcolumnsservice.FormColumnsService,
        typeof _gridsservice.GridsService === "undefined" ? Object : _gridsservice.GridsService,
        typeof _formsservice.FormsService === "undefined" ? Object : _formsservice.FormsService,
        typeof _galleriesservice.GalleriesService === "undefined" ? Object : _galleriesservice.GalleriesService,
        typeof _calendarsservice.CalendarsService === "undefined" ? Object : _calendarsservice.CalendarsService,
        typeof _kanbansservice.KanbansService === "undefined" ? Object : _kanbansservice.KanbansService,
        typeof _bulkdataaliasservice.BulkDataAliasService === "undefined" ? Object : _bulkdataaliasservice.BulkDataAliasService,
        typeof _hooksservice.HooksService === "undefined" ? Object : _hooksservice.HooksService,
        typeof _viewsservice.ViewsService === "undefined" ? Object : _viewsservice.ViewsService
    ])
], ImportService);
